export { OptedInDocumentTypesSection } from './OptedInDocumentTypesSection';
export {
  OPTED_IN_DOCUMENT_TYPES_COPY,
  OPTED_IN_DOCUMENT_TYPE_LABELS,
} from './optedInDocumentTypesCopy';
